/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import { useEffect, useState } from 'react';
import { resolve } from 'reporting-data/main';
import { SEARCH } from 'reporting-data/constants/configTypes';
import { isSalesAnalyticsWidget } from '../customWidgets/lib/salesExplorer';
export function useDrilldownRecordCount(drilldownReport) {
  const [recordCount, setRecordCount] = useState(null);
  useEffect(() => {
    if (drilldownReport.getIn(['config', 'configType']) === SEARCH && !isSalesAnalyticsWidget(drilldownReport)) {
      resolve(drilldownReport, {
        v2Datasets: true
      }).then(resolved => {
        setRecordCount(resolved.getIn(['primary', 'data', 'paginationSize'], null));
      });
    }
  }, [drilldownReport]);
  return recordCount;
}